import { useInboxEnabled } from "./useInboxEnabled";
import { useRecentNotifications } from "./useRecentNotifications";

/**
 * The badge number: how many notifications are in Recent. Zero while the
 * `disable-inbox` kill switch is on, whatever is still in the cache.
 */
export const useRecentNotificationCount = (): number => {
  const enabled = useInboxEnabled();
  const { data } = useRecentNotifications();
  return enabled ? (data?.count ?? 0) : 0;
};
